var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgNftMint = function SvgNftMint(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "nft-mint_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#nft-mint_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12 20.75a.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.535v-7.186a7.483 7.483 0 0 1-2.883-.57 7.414 7.414 0 0 1-2.436-1.626A7.252 7.252 0 0 1 4.316 8.18 7.628 7.628 0 0 1 3.76 5.3v-.616c0-.253.085-.465.257-.637a.865.865 0 0 1 .637-.257h.615c.981 0 1.93.191 2.85.574.918.383 1.73.927 2.435 1.632a7.084 7.084 0 0 1 1.287 1.753c.336.645.576 1.33.72 2.056.116-.2.245-.389.386-.568.142-.179.3-.355.474-.53a7.458 7.458 0 0 1 2.437-1.63 7.434 7.434 0 0 1 2.883-.575h.615c.253 0 .466.085.637.257a.865.865 0 0 1 .257.637v.615c0 1-.192 1.96-.575 2.882a7.458 7.458 0 0 1-1.63 2.437 7.288 7.288 0 0 1-2.425 1.615 7.534 7.534 0 0 1-2.87.556V20c0 .213-.072.391-.216.535a.727.727 0 0 1-.534.215Zm-.74-9.461c0-.8-.155-1.562-.463-2.287a6.087 6.087 0 0 0-1.312-1.938 6.088 6.088 0 0 0-1.938-1.312 5.785 5.785 0 0 0-2.287-.463c0 .8.15 1.567.45 2.3.3.733.733 1.383 1.3 1.95.566.567 1.216 1 1.95 1.3.733.3 1.5.45 2.3.45Zm1.49 2.712a5.924 5.924 0 0 0 4.225-1.75 6.05 6.05 0 0 0 1.313-1.95c.308-.734.462-1.5.462-2.3-.8 0-1.567.154-2.3.462a6.048 6.048 0 0 0-1.95 1.313A5.917 5.917 0 0 0 12.75 14Z",
    fill: "currentColor"
  }))));
};
export default SvgNftMint;